import { useState, useEffect, useRef } from 'react';
import { useShallow } from 'zustand/shallow';
import { OTPContainer } from 'mobily-ui-library';
import { useGlobalStore } from '../stores/globalStore';
import { useCheckoutStore } from '../stores/checkoutStore';
import { useResendOTP } from '../hooks/useResendOTP';
import { useValidateOTP } from '../hooks/useValidateOTP';
import { useSendOTP } from '../hooks/useSendOTP';
import { t } from 'i18next';

const win: any = window;

export const OTPScreen = () => {
    const [showWrongOTPError, setShowWrongOTPError] = useState(false);
    const [disableTimer, setDisableTimer] = useState(false);
    const [disableResend, setDisableResend] = useState(false);
    const [disableOTPInput, setDisableOTPInput] = useState(false);
    const hasSentOTP = useRef(false);

    const sendOTP = useSendOTP();
    const resendOTP = useResendOTP();
    const validateOTP = useValidateOTP();

    const { otpReferenceId, setOtpReferenceId, lang, formState } = useGlobalStore(useShallow((state) => {
        return {
            otpReferenceId: state.otpReferenceId,
            lang: state.lang,
            formState: state.formState,
            setOtpReferenceId: state.setOtpReferenceId,
        };
    }))
    const {
        goToNextSection,
    } = useCheckoutStore(useShallow((state) => {
        return {
            goToNextSection: state.goToNextSection,
        };
    }));

    const onSuccess = () => {
        goToNextSection();
    }

    const prefixedCnum = formState.contactNumber ? `9665${formState.contactNumber}` : "";
    const customerName = formState.firstName && formState.lastName ? `${formState.firstName} ${formState.lastName}` : "";
    const rtl = lang === 'ar';

    useEffect(() => {
        if (!hasSentOTP.current && customerName && prefixedCnum) {
            hasSentOTP.current = true;
            sendOTP({ number: prefixedCnum, customerName: customerName }).then((res) => {
                if (res.data?.data?.refId) {
                    setOtpReferenceId(res.data?.data?.refId);
                }
            });
        }
    }, [customerName, prefixedCnum, sendOTP, setOtpReferenceId]);

    return (
        <div className='otpContainerWrapper'>
            <OTPContainer
                config={{
                    validateOtpApi: async (otp: string) => {
                        if (otp && otpReferenceId && /^\d{4}$/.test(otp)) {
                            const res = await validateOTP({ otp: otp, refId: otpReferenceId });
                            if (res.status === 204) {
                                return {
                                    success: true,
                                    message: t('otp_Validated_Successfully')
                                };
                            }
                            if (res.status === 260) {
                                const sourceCode = res.data?.status?.sourceCode;
                                const errorMessage = lang === "ar" ? res.data?.status?.messageAr : res.data?.status?.messageEn;

                                switch (sourceCode) {
                                    case "MAPI-260-2": {
                                        setShowWrongOTPError(true);
                                        return {
                                            success: false,
                                            message: t('wrong_Code')
                                        };
                                    }
                                    case "MAPI-260-3": {
                                        return {
                                            success: false,
                                            message: errorMessage
                                        };
                                    }
                                    case "MAPI-260-4": {
                                        setDisableResend(true);
                                        setDisableOTPInput(true);
                                        setTimeout(() => {
                                            window.location.replace(win['home_fiber_url']);
                                        }, 2000);
                                        return {
                                            success: false,
                                            message: errorMessage
                                        };
                                    }
                                }


                                return {
                                    success: false,
                                    message: errorMessage
                                };
                            }
                        }
                    },
                    resendOtpApi: async () => {
                        if (otpReferenceId) {
                            const res = await resendOTP(otpReferenceId);
                            if (res.status === 204) {
                                return {
                                    success: true,
                                    message: ""
                                };
                            }
                            if (res.status === 260) {
                                const sourceCode = res.data?.status?.sourceCode;
                                const errorMessage = lang === "ar" ? res.data?.status?.messageAr : res.data?.status?.messageEn;
                                if (sourceCode === "MAPI-260-1") {
                                    setDisableTimer(true);
                                    setDisableResend(true);
                                    return {
                                        success: false,
                                        message: errorMessage
                                    }
                                }
                            }
                        }
                    },
                    messages: {
                        genericError: t('Something_Went_Wrong'),
                    },
                    onSuccess: onSuccess,
                    resendAfter: 120,
                }}
                heading={t('confirm_Its_you')}
                subHeading={t("sent_One_Time_Code", { contactNumber: `05${formState.contactNumber}` })}
                rtl={rtl}
                didnotReceiveText={t("did_Not_Receive_Code") + " "}
                sendAgainText={t("send_Again")}
                verifyTimerText={t("request_New_Code")}
                showWrongOTPError={showWrongOTPError}
                disableResend={disableResend}
                disableOTPInput={disableOTPInput}
                disableTimer={disableTimer}
            />
        </div>
    );
};